import { render, staticRenderFns } from "./investmentClues4.vue?vue&type=template&id=b0d3f7f2&"
import script from "./investmentClues4.vue?vue&type=script&lang=js&"
export * from "./investmentClues4.vue?vue&type=script&lang=js&"
import style0 from "./investmentClues4.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports